import axios from 'axios';
import { BASE_URL } from './config';

export async function sendNotifications({ users, product, message, urgent, token }){
  try {

    const _users = users.map(({ phone_tokens, email, username, key, name }) => 
      ({ phone_tokens, email, username, key, name})
    )

    return await axios.post(`${BASE_URL}/sendNotifications`, {
      product: JSON.stringify(product), 
      users: JSON.stringify(_users),
      urgent: !!urgent ? 'urgent' : '',
      message
    }, {
      headers: {
        'Authorization': token
      }
    })
  } catch(e) {
    throw  e;
  }
}



// WEBPACK FOOTER //
// ./src/utils/notificationService.js